var map = {
	"./bg.jpg": 4169,
	"./bg.png": 8337,
	"./bg2.jpg": 8903,
	"./bg3.jpg": 7514,
	"./bg_test.png": 5454,
	"./bg_top.png": 4597,
	"./cryptomus-logo.png": 9768,
	"./footer/bg.jpg": 651,
	"./img_0.png": 4946,
	"./img_1.png": 9163,
	"./img_10.png": 3331,
	"./img_11.png": 2570,
	"./img_12.png": 1553,
	"./img_13.png": 8840,
	"./img_14.png": 8455,
	"./img_15.png": 8462,
	"./img_16.png": 7237,
	"./img_17.png": 3372,
	"./img_18.png": 3675,
	"./img_19.png": 6370,
	"./img_2.png": 832,
	"./img_20.png": 5970,
	"./img_21.png": 7099,
	"./img_22.png": 7248,
	"./img_23.png": 4153,
	"./img_24.png": 1078,
	"./img_25.png": 95,
	"./img_26.png": 1188,
	"./img_27.png": 2317,
	"./img_28.png": 1898,
	"./img_29.png": 7107,
	"./img_3.png": 5657,
	"./img_30.png": 5149,
	"./img_31.png": 5204,
	"./img_32.png": 9855,
	"./img_4.png": 5830,
	"./img_5.png": 2159,
	"./img_6.png": 7508,
	"./img_7.png": 7453,
	"./img_8.png": 7594,
	"./img_9.png": 5171,
	"./testimonial/bg.png": 4817,
	"./testimonial/bg_top.png": 9218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;